/*
  creates google maps marker
  - I assign additional iformation about marker (each marker is an airport), like IATA, full name etc.
*/
const createMarker = (marker, currency) => {
  const newMarker = new google.maps.Marker({
    id: marker.id,
    position: new google.maps.LatLng(marker.x, marker.y),
    name: marker.name,
    iata: marker.iata,
    price: marker.price,
    visible: false // hide all markers, we display infoBoxes instead
  })

  return newMarker
}

export default createMarker



// WEBPACK FOOTER //
// ./app/markers/createMarker.js